import { configureStore } from "@reduxjs/toolkit";
import siteReducer from "./site/site";
import postFormReducer from "./postForm/postForm";
import feedFormReducer from "./feedForm/feedForm";
import incidentFormReducer from "./incidentForm/incidentForm";
import commentFormReducer from "./commentForm/commentForm";
import lightboxReducer from "./lightbox/lightbox";
import accountReducer from "./settings/account";

export const store = configureStore({
    reducer: {
        site: siteReducer,
        postForm: postFormReducer,
        incidentForm: incidentFormReducer,
        feedForm: feedFormReducer,
        commentForm: commentFormReducer,
        lightbox: lightboxReducer,
        account: accountReducer
    }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
